"use client";

import { ArrowLeft } from "lucide-react";
import { HStack } from "../layout/HStack";
import { cn } from "../utils/mergeClassNames";

export interface BackNavProps {
  onBack?: () => void;
  className?: string;
}

/**
 * BackNav component for navigation back button
 */
export const BackNav = ({ onBack, className }: BackNavProps) => {
  return (
    <HStack
      className={cn("w-fit cursor-pointer py-4", className)}
      onClick={onBack}
    >
      <ArrowLeft className="h-6 w-6" />
    </HStack>
  );
};
